export const RECENT_FABRIC = 'RECENT_FABRIC_ID';
export const SESSION_FABRIC_MAP = 'SESSION_FABRIC_MAP';
export const LAST_VISITED_IDE_URL = 'LAST_VISITED_IDE_URL';
export const LAST_OBSERVATION_IDE_URL = 'LAST_OBSERVATION_IDE_URL';
export const LAST_JOB_IDE_URL = 'LAST_JOB_IDE_URL';
/** One-shot handoff so the post-signup onboarding landing can resume the signup journey's timing
 * across the hard reload `redirectAfterAuth` does — see `common/metrics/journey/journeys/signup.ts`. */
export const SIGNUP_JOURNEY_HANDOFF_KEY = 'signup.journey.handoff';
export const DOMAIN_URL_KEY = 'domain-url';
export const WORKFLOW_DEBUG_MODE_KEY = 'config.debug.enable';
export const LOG_WEBSOCKET_MESSAGE_ENABLED_KEY = 'config.logWebsocketMessage.enabled';
export const EXECUTION_MORE_LOG = 'config.execution.logDetail';
export const WEBSOCKET_COMPRESSION_KEY = 'config.websocketCompression.disable';
export const FILE_SYNC_OBSERVABILITY_KEY = 'config.fileSyncObservability.enable';
export const SPARK_SHELL_COMMANDS_KEY = 'recentSparkShellCommands';
export const CODE_VIEW_OPENED_FILE_INFO = 'codeViewOpenedFile';
export const PROJECT_BUILD_ENABLED_KEY = 'config.project.build.enabled';
export const DBT_MACRO_ENABLED_KEY = 'config.dbt.macro.enabled';
export const DBT_PROJECT_DEPENDENCY_ENABLED_KEY = 'config.dbt.projectDependency.enabled';
export const DBT_SHOW_ALL_PROVIDERS = 'config.dbt.showAllProviders';
export const COPILOT_ENABLED_KEY = 'config.copilot.enabled';
export const ENABLE_METRICS_CONSOLE_LOGGING_KEY = 'config.metricsConsoleLogging.enabled';
export const isDebugMode = () => localStorage.getItem(WORKFLOW_DEBUG_MODE_KEY) === 'true';
export const isWebSocketLoggingEnabled = () => localStorage.getItem(LOG_WEBSOCKET_MESSAGE_ENABLED_KEY) === 'true';
export const isWebsocketCompressionEnabled = localStorage.getItem(WEBSOCKET_COMPRESSION_KEY) !== 'true';
export const isFileSyncObservabilityEnabled = () => localStorage.getItem(FILE_SYNC_OBSERVABILITY_KEY) === 'true';
export const OBSERVATION_FABRIC = 'observation.fabric';
export const EXPECTATION_DEFAULT_INTERVAL = 'expectation.interval';
export const ENABLE_FULLSTORY_FOR_PROPHECY_EMAIL = 'fullstory.prophecy.user.enabled';
export const ENABLE_TRANSPILER_LANGUAGE = 'transpiler.language';
export const UNDO_REDO_KEY = 'config.history.enabled';
export const CARRY_FORWARD_SLUG_ENABLED = 'config.carryForwardSlug.enabled';
const REACT_QUERY_DEVTOOLS_KEY = 'config.reactQueryDevtools.enabled';
export const isReactQueryDevtoolsEnabled = localStorage.getItem(REACT_QUERY_DEVTOOLS_KEY) === 'true';
export const ENABLE_SPARK_SORT_FILTER = 'config.sparkSortAndFilter.enabled';
export const SPARK_PROPHECY_MANAGED_TIMEOUT = 'spark.prophecyManaged.timeout.editable';
export const NEW_PORT_ADDED_TOAST_SHOWN = 'config.newPortAdded.shown';
//Note: We store selected algorithm on localStorage, so for next layout that becomes the selected option for that user.
export const SELECTED_LAYOUT_ALGO_KEY = 'graph.layout.algo';

const TRANSPILER_JOB_KEY = 'config.transpiler.job.enabled';
export const isTranspilerJobEnabled = localStorage.getItem(TRANSPILER_JOB_KEY) === 'true';
export const EDIT_DEFAULT_TEMPLATE_ENABLED_KEY = 'config.editDefaultTemplate.enabled';
export const ALLOW_CONFIG_TAGS = 'config.configTags.enabled';
export const ALLOW_SECRET_TYPE_CONFIG = 'config.secretType.enabled';
export const ALLOW_PARAM_CONFIG = 'config.paramConfig.enabled';
export const DEMO_BUSINESS_RULES = 'config.businessRules.demo';
export const isBusinessRulesDemoEnabled = localStorage.getItem(DEMO_BUSINESS_RULES) === 'true';
export const COPILOT_AUDIO_PROMPT_ENABLED = 'config.copilot.audio.enabled';
export const ALLOW_FABRIC_ACCESS_CLUSTER_ADMIN = 'config.fabricAccessClusterAdmin.enabled';
export const ALLOW_DATA_PROFILE_ON_INTERIMS = 'config.dataProfile.enabled';
export const DISABLE_ZSTD_COMPRESSION = 'config.zstdCompression.disabled';
export const PROPHY_CREDENTIALS = 'prophecy-credentials';
export const ENABLE_FILE_GENERATION_ON_SQL_RUN = 'enable.sql.run.file.generation';
export const ENABLE_TRANSPILER_ENTITY_ADD_ALL = 'enable.transpiler.add.all';
export const ENABLE_OAUTH_FABRIC_TESTING = 'enable.oauth.fabric.testing';
export const ENABLE_SAP = 'config.sap.enabled';
export const SAP_AI_TERMS_DEFERRED_THIS_LOGIN = 'config.sap.aiTerms.deferredThisLogin';
export const ENABLE_GOOGLE_OEM = 'config.google.oem.enabled';
export const ENABLE_ORCHESTRATOR_DEBUG_MODE = 'config.orchestrator.debug.enabled';
export const ENABLE_ANALYZER_FOR_INFORMATICA = 'enable.analyzer.for.informatica';
export const ENABLE_VERTICAL_APPS = 'config.vertical.app.enabled';
export const ENABLE_SHARE_AND_REPLAYS_ENABLED = 'config.share.and.replays.enabled';
export const ENABLE_GEMBUILDER_EDITOR = 'config.gembuilder.editor.enabled';
export const EXIT_REPLAY_REMEMBER = 'config.replay.exit.enabled';
export const RESUME_REPLAY_REMEMBER = 'config.replay.resume.enabled';
export const IS_REPO_ENABLED_IN_DEPENDENCY = 'config.dependency.repo.enabled';
export const REPLAY_CURRENT_PLAYED_STEP = 'config.replay.onboarding.currentStep';
export const LAST_SHOWN_USAGE_ALERT_LIMIT = 'lastShownUsageAlertLimit';
export const ENABLE_TRANSPILER_IICS = 'enable.transpiler.iics';
export const DISABLE_AUTO_SWITCH_IN_CHAT_MODE = 'config.copilot.autoSwitchInChatMode.disabled';
export const ENABLE_DATA_HARMONIZATION = 'config.data_harmonization.enabled';
export const LAST_HARMONIZATION_FABRIC = 'last-harmonization-fabric';
export const SHOW_JPMC_POST_LOGIN_COPILOT_POPUP_ACKNOWLEDGED = 'config.jpmcPostLoginCopilotPopupAcknowledged';
export const ENABLE_COPY_PASTE_IN_DIFFERENT_PROVIDERS = 'config.copyPaste.inDifferentProviders.enabled';
export const COPILOT_AGENT_LAST_SESSION_ID_PREFIX = 'copilot.agent.lastSessionId';
export const ENABLE_HISTORICAL_RUN_SNAPSHOTS = 'config.historical.run.snapshots.enabled';
/** Base64-encoded localStorage key for share-mode agent v4 prompt limit. */
export const SHARE_MODE_AI_V4_CHAT_LIMIT_REACHED = btoa('config.share.mode.agent.v4.chat.limit.reached');
export const PROJECT_BROWSER_WIDTH_KEY = 'config.projectbrowser.width';
export const CHAT_PANEL_WIDTH_KEY = 'config.chat.panel.width';
export const ENABLE_SQL_LINEAGE = 'config.sql.lineage.enabled';
export const ENABLE_STRUCTURED_FINANCE = 'config.structuredFinance.enabled';
export const ENABLE_SEMANTIC_LAYER = 'config.semanticLayer.enabled';
export const ENABLE_PAGINATION_LOCAL_VARIABLE_FLAG = 'config.copilot.pagination.enabled';
export const ANALYSIS_ENABLE_SCROLL_POSITION = 'config.analysis.scroll.position';
export const CDM_TESTS_COLUMN_FILTER_KEY = 'config.cdm.tests.columnFilter';
export const CDM_TESTS_COLUMN_SORT_MODE_KEY = 'config.cdm.tests.columnSortMode';
export const SHOW_DEV_FILTERS = 'SHOW_DEV_FILTERS';
export const isDevFiltersEnabled = () => localStorage.getItem(SHOW_DEV_FILTERS) === 'true';
export const CONNECTION_REAUTHENTICATE_INTERVAL = 'config.connection.reauthenticate.interval';
export const FULLSTORY_ENABLE_KEY = 'config.fullstory.enable';
export const EXCEL_FEATURE_ENABLE_KEY = 'config.ui.excel.enable';
export const SNOWFLAKE_PWD_AUTH_DIALOG_DISMISSED_AT_KEY = 'snowflake.pwdAuthDialog.dismissedAt';
export const ENABLE_SHARED_INTERIM_TABLE = 'config.sharedInterimTable.enabled';
export const ENABLE_SHARED_CHART_CARD = 'config.sharedChartCard.enabled';
